import { GET_SUPERVISORS, EDIT_SUPERVISOR, NEW_SUPERVISOR, DELETE_SUPERVISOR } from '../actionCreators/supervisors';

export default function supervisors (state = null, action) {
    switch (action.type) {
        case GET_SUPERVISORS :
            return action.supervisors;
        case EDIT_SUPERVISOR :
            if(action.supervisor === null) {
                return state;
            } else {
                const index = state.indexOf(state.find(admin => admin._id === action.supervisor._id));
                state.splice(index, 1, action.supervisor);
                return state;
            }
        case NEW_SUPERVISOR :
            return action.supervisor===null ? state : state.concat(action.supervisor);
        case DELETE_SUPERVISOR :
            return action.id===null ? state : state.filter(admin => admin._id !== action.id);
        default :
            return state;
    }
} 